<template>
    <div>
        <div class="card mb-3" id="provider">
            <div class="card-header headline provider">
                <h2 class="text-white d-inline" v-if="transactionType === 'payment'">پرداخت به تامین کننده</h2>
                <h2 class="text-white d-inline" v-if="transactionType === 'receive'">دریافت از تامین کننده</h2>
            </div>
            <div class="col-12  m-2" >
                <div class="input-group">
                    <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fa fa-search"></i>
                    </span>
                    </div>
                    <input type="text" class="form-control" placeholder="جستجو..." @input="onSearchInput"
                           v-model="searchString">
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-12 mt-5" v-if="providers.length < 1">
                        <h3 class="text-center no-item-alert">تامین کننده ثبت نشده است!</h3>
                    </div>
                    <div class="col-lg-3 mb-3" v-for="(item, index) in providers">
                        <div class="card shadow" @click="onCardClicked(index)">
                            <div class="row p-2">
                                <div class="col-lg-12 mt-3">
                                    <h4 class="text-center">{{item.outSourceName}}</h4>
                                    <span>شماره تماس:</span>
                                    <span>{{item.phoneNumber}}</span>
                                    <br/>
                                    <span>کد ملی:</span>
                                    <span>{{item.branchCode}}</span>
                                    <br/>
                                    <span>باقیمانده: </span>
                                    <span>{{item.remain<0 ? "(" + (item.remain*-1).toLocaleString() +"-)": item.remain.toLocaleString()}}</span>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!--<div v-if="providers.length > 7 && lastRespond.length > 7" class="col-lg-12 text-center mb-3" @click="getproviders">
                        <button class="btn btn-success">نمایش حساب های بیشتر</button>
                    </div>-->
                    <div class="col-lg-12">
                        <div class="sk-circle" id="loadings">
                            <div class="sk-circle1 sk-child"></div>
                            <div class="sk-circle2 sk-child"></div>
                            <div class="sk-circle3 sk-child"></div>
                            <div class="sk-circle4 sk-child"></div>
                            <div class="sk-circle5 sk-child"></div>
                            <div class="sk-circle6 sk-child"></div>
                            <div class="sk-circle7 sk-child"></div>
                            <div class="sk-circle8 sk-child"></div>
                            <div class="sk-circle9 sk-child"></div>
                            <div class="sk-circle10 sk-child"></div>
                            <div class="sk-circle11 sk-child"></div>
                            <div class="sk-circle12 sk-child"></div>
                        </div>
                    </div>
                    <div v-if="!autoload && providers.length < dataCount" class="col-lg-12 text-center my-3">
                        <button class="btn btn-success" @click="getproviders">نمایش موارد بیشتر
                            ({{providers.length}}/{{dataCount}})</button>
                        <div class="col-2 offset-5 my-2">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">تعداد نمایش</span>
                                </div>
                                <input class="form-control" type="text" @change="changePageSize" v-model="queryParams.pageSize">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--<div class="modal fade" id="provider-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 v-if="transactionType === 'payment'" class="modal-title text-white">پرداخت به {{provider.outSourceName}}</h5>
                        <h5 v-if="transactionType === 'receive'" class="modal-title text-white">دریافت از {{provider.outSourceName}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-lg-3 offset-lg-3 mb-2">
                                <div :class="{active: opening.isDebtor === true}" class="card opening p-2" @click="onDebtorClicked">
                                    <h4 class="text-center mb-0">طلب من</h4>
                                </div>
                            </div>
                            <div class="col-lg-3 mb-2">
                                <div :class="{active: opening.isDebtor === false}" class="card opening p-2" @click="onCreditorClicked">
                                    <h4 class="text-center mb-0">بدهی من</h4>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-6 offset-lg-3 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">موجودی اولیه</span>
                                    </div>
                                    <input class="form-control" type="number" v-model="opening.price">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                        <button type="button" class="btn btn-primary" @click="onModalOk">ذخیره</button>
                    </div>
                </div>
            </div>
        </div>-->
    </div>
</template>


<script>
    import * as $ from 'jquery';
    import axios from 'axios';
    import Vue from 'vue';
    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";
    import EventBus from "../../_framework/event-bus.js";

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(()=> {
        $("#voucherData").modal("show");
    });

    export default {
        name: 'transaction-provider',
        components: {},
        data() {
            return {

                providers: [],
                queryParams: {
                    pageSize: 12,
                    pageIndex: 0,
                    name: "",
                    types: 5
                },
                opening: {
                    code: "",
                    price: 0,
                    isDebtor: true,
                    voucherId: 0,
                },

                params: {
                    mode: 'create'
                },
                searchString: "",
                transactionType: "",
                transaction: {
                    fromCode: "",
                    toCode: "",
                    code: "",
                    price: 0,
                    check: {
                        outSourceName: "",
                        checkNumber: "",
                        checkDate: "",
                        checkPersianDate: "",
                        bankName: "",
                        branchName: "",
                        branchCode: ""
                    }
                },
                dataCount: 0,

                autoload: false
            }
        } ,
        mounted() {
            this.autoload = JSON.parse(localStorage.getItem("autoload"));
            this.transactionType = this.$parent.type;
            EventBus.$on('transactionType', value => {
                this.transactionType = value;
            });
            new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                this.providers = response.data.data;
                this.dataCount = response.data.count;
                $("#loadings").hide();
            }).catch(error => {
                // error
                Utils.handleErrorWithNotification(error.response.message, this.$noty);
            });

            if (JSON.parse(localStorage.getItem("autoload"))) {
                $(window).on("scroll", () => {
                    if (Utils.onBottomReached() && this.providers.length < this.dataCount) {
                        $("#loading").show();
                        this.getproviders(-1);
                    }
                });
            }
        },
        methods: {
            changePageSize(e){
                this.getproviders(-1);
            },
            getproviders(page) {
                if (page === -1) {
                    this.queryParams.pageIndex = 0;
                    this.vouchers = [];
                } else {
                    this.queryParams.pageIndex++;
                }
                $("#loadings").show();
                new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                    this.providers.push.apply(this.providers, response.data.data);
                    this.dataCount = response.data.count;
                    $("#loadings").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                });
            },
            onCardClicked(index) {
                this.transaction.outSourceName = this.providers[index].outSourceName;
                if (this.transactionType === 'payment') {
                    this.transaction.toCode = this.providers[index].code;
                } else {
                    this.transaction.fromCode = this.providers[index].code;
                }
                this.$router.push({
                    name: 'transaction-payment',
                    params: {
                        transaction: this.transaction,
                        type: this.transactionType
                    }
                })
            },
            onModalOk() {
                if (this.params.mode === 'create') {
                    this.onCreate(this.opening);
                } else {
                    this.onUpdate(this.opening);
                }
            },
            onDebtorClicked() {
                this.opening.isDebtor = true;
            },
            onCreditorClicked() {
                this.opening.isDebtor = false;
            },
            onCreate(opening) {
                new BaseService('outsource', '/opening').create(opening).then(response => {
                    this.$noty.success("موجودی اولیه با موفقیت افزوده شد.");
                    $("#provider-modal").modal("hide");
                    this.queryParams.pageIndex = 0;
                    new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                        this.providers = response.data.data;
                        $("#loading").hide();
                        this.opening.code = "";
                        this.opening.price = 0;
                        this.opening.isDebtor = true;
                    }).catch(error => {
                        // error
                        Utils.handleErrorWithNotification(error.response.message, this.$noty);
                    });
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                });
            },
            onUpdate(opening) {
                new BaseService('outsource', '/opening').update(opening).then(response => {
                    this.$noty.success("موجودی اولیه با موفقیت ویرایش شد.");
                    $("#provider-modal").modal("hide");
                    this.queryParams.pageIndex = 0;
                    new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                        this.providers = response.data.data;
                        $("#loading").hide();
                        this.opening.code = "";
                        this.opening.price = 0;
                        this.opening.isDebtor = true;
                    }).catch(error => {
                        // error
                        Utils.handleErrorWithNotification(error.response.message, this.$noty);
                    });
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                });
            },
            onSearchInput() {
                this.queryParams.name = this.searchString;
                this.queryParams.pageIndex = 0;
                this.providers =[];
                new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                    this.providers.push.apply(this.providers, response.data.data);
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                });
            },
        },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            next();
        },
    }
</script>

<style lang="scss" scoped>
    .card.opening {
        border-radius: 0.5rem !important;
        border: 2px solid #f50057;
        transition: all 0.3s;
    }

    .card.opening:hover {
        cursor: pointer;
        background: #eee;
    }

    .card.opening.active {
        background: #f50057;
        color: white;
    }
</style>